import React from 'react';
import { BRAND } from '../../constants/main';
import { KeywordsStyledAC } from './AC/KeywordsStyled.AC';
import { KeywordsStyledAP } from './AP/KeywordsStyled.AP';
import { KeywordsStyledDS } from './DS/KeywordsStyled.DS';
import { KeywordsStyledOV } from './OV/KeywordsStyled.OV';
import { KeywordsStyled } from './KeywordsStyled';
import { SC } from '../../styles/theme';

export interface KeywordsTemplateProps extends SC {}

const Keywords = (props: KeywordsTemplateProps) => {
    if (BRAND === 'AC') return <KeywordsStyledAC {...props} />;
    if (BRAND === 'AP') return <KeywordsStyledAP {...props} />;
    if (BRAND === 'DS') return <KeywordsStyledDS {...props} />;
    if (BRAND === 'OV') return <KeywordsStyledOV {...props} />;
    return <KeywordsStyled {...props} />;
};

export default Keywords;
